"use strict";
import { __require as E } from "./index.es525.js";
import { __require as d } from "./index.es526.js";
var c, y;
function O() {
  if (y) return c;
  y = 1;
  var a = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var l = /* @__PURE__ */ E(), i = {}, v = /* @__PURE__ */ d();
    a = function(r) {
      var t = "Warning: " + r;
      typeof console < "u" && console.error(t);
      try {
        throw new Error(t);
      } catch {
      }
    };
  }
  function f(r, t, n, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var o in r)
        if (v(r, o)) {
          var e;
          try {
            if (typeof r[o] != "function") {
              var p = Error(
                (s || "React class") + ": " + n + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            e = r[o](t, o, s, n, null, l);
          } catch (m) {
            e = m;
          }
          if (e && !(e instanceof Error) && a(
            (s || "React class") + ": type specification of " + n + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof e + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), e instanceof Error && !(e.message in i)) {
            i[e.message] = !0;
            var h = u ? u() : "";
            a(
              "Failed " + n + " type: " + e.message + (h ?? "")
            );
          }
        }
    }
  }
  return f.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, c = f, c;
}
export {
  O as __require
};
//# sourceMappingURL=index.es527.js.map
